<!--
  Full view of the Provisionszeile (cp.ProvisionContract). Exactly ONE shared component per
  active navItem.
-->
@if (navigationItems && initialized) {

    <div class="cp-provision-contract-full mt-4">

        @if (activeNavigationItem?.action == 'baseData') {
            <cp-provision-contract-base-data
                    [provisionContractId]="objectIdentifier.objectId">
            </cp-provision-contract-base-data>
        }

        <!-- navItem "Berechnung": carries the nullable calculation fields the next ProvisionRun
             fills. They render the explicit German pending hint instead of an empty cell
             (FD-7(a)); "Berater ermittelt" only while Provisionssätze exist (FD-8 / BT-5). -->
        @if (activeNavigationItem?.action == 'calculation') {
            <cp-provision-contract-calculation
                    [provisionContractId]="objectIdentifier.objectId">
            </cp-provision-contract-calculation>
        }

        @if (activeNavigationItem?.action == 'contractAgents') {
            <cp-provision-contract-contract-agents
                    [provisionContractId]="objectIdentifier.objectId">
            </cp-provision-contract-contract-agents>
        }

        @if (activeNavigationItem?.action == 'cancellation') {
            <cp-provision-contract-cancellation
                    [provisionContractId]="objectIdentifier.objectId">
            </cp-provision-contract-cancellation>
        }

    </div>

}
